import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Navigation from './Navigation';
import Footer from './Footer';
const TermsContent: React.FC = () => {
  const { language } = useLanguage();

  const termsContent = {
    fr: {
      title: 'Conditions Générales d\'Utilisation',
      lastUpdated: 'Dernière mise à jour : 2026',
      sections: [
        {
          title: '1. Acceptation des conditions',
          content: 'En accédant et en utilisant le site web de Sparkr, vous acceptez d\'être lié par ces conditions générales d\'utilisation. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser notre site web.',
        },
        {
          title: '2. Utilisation du site',
          content: 'Vous vous engagez à utiliser notre site web uniquement à des fins légales et de manière à ne pas violer les droits d\'autrui ou restreindre l\'utilisation du site par d\'autres utilisateurs.',
        },
        {
          title: '3. Propriété intellectuelle',
          content: 'Tout le contenu de ce site web, y compris les textes, graphiques, logos, images et logiciels, est la propriété de Sparkr ou de ses concédants de licence et est protégé par les lois sur la propriété intellectuelle.',
        },
        {
          title: '4. Limitation de responsabilité',
          content: 'Sparkr ne sera pas responsable des dommages directs, indirects, accessoires ou consécutifs résultant de l\'utilisation ou de l\'impossibilité d\'utiliser ce site web.',
        },
        {
          title: '5. Liens externes',
          content: 'Notre site web peut contenir des liens vers des sites web externes. Nous ne sommes pas responsables du contenu ou des pratiques de confidentialité de ces sites tiers.',
        },
        {
          title: '6. Modifications des conditions',
          content: 'Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications entreront en vigueur dès leur publication sur cette page.',
        },
        {
          title: '7. Droit applicable',
          content: 'Ces conditions sont régies par les lois en vigueur dans le pays où Sparkr opère. Tout litige sera soumis à la juridiction exclusive des tribunaux compétents.',
        },
        {
          title: '8. Contact',
          content: 'Pour toute question concernant ces conditions, veuillez nous contacter à contact@sparkr.tech.',
        },
      ],
    },
    en: {
      title: 'Terms and Conditions',
      lastUpdated: 'Last updated: 2026',
      sections: [
        {
          title: '1. Acceptance of Terms',
          content: 'By accessing and using Sparkr\'s website, you agree to be bound by these terms and conditions. If you do not agree to these terms, please do not use our website.',
        },
        {
          title: '2. Use of Website',
          content: 'You agree to use our website only for lawful purposes and in a way that does not infringe the rights of others or restrict the use of the website by other users.',
        },
        {
          title: '3. Intellectual Property',
          content: 'All content on this website, including text, graphics, logos, images, and software, is the property of Sparkr or its licensors and is protected by intellectual property laws.',
        },
        {
          title: '4. Limitation of Liability',
          content: 'Sparkr shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use this website.',
        },
        {
          title: '5. External Links',
          content: 'Our website may contain links to external websites. We are not responsible for the content or privacy practices of these third-party sites.',
        },
        {
          title: '6. Changes to Terms',
          content: 'We reserve the right to modify these terms at any time. Changes will take effect immediately upon posting on this page.',
        },
        {
          title: '7. Governing Law',
          content: 'These terms are governed by the laws of the country where Sparkr operates. Any disputes will be subject to the exclusive jurisdiction of the competent courts.',
        },
        {
          title: '8. Contact',
          content: 'For any questions regarding these terms, please contact us at contact@sparkr.tech.',
        },
      ],
    },
    es: {
      title: 'Términos y Condiciones',
      lastUpdated: 'Última actualización: 2026',
      sections: [
        {
          title: '1. Aceptación de los términos',
          content: 'Al acceder y utilizar el sitio web de Sparkr, acepta estar sujeto a estos términos y condiciones. Si no acepta estos términos, no utilice nuestro sitio web.',
        },
        {
          title: '2. Uso del sitio web',
          content: 'Usted acepta usar nuestro sitio web solo para fines legales y de una manera que no infrinja los derechos de otros o restrinja el uso del sitio web por parte de otros usuarios.',
        },
        {
          title: '3. Propiedad intelectual',
          content: 'Todo el contenido de este sitio web, incluidos textos, gráficos, logotipos, imágenes y software, es propiedad de Sparkr o sus licenciantes y está protegido por las leyes de propiedad intelectual.',
        },
        {
          title: '4. Limitación de responsabilidad',
          content: 'Sparkr no será responsable de ningún daño directo, indirecto, incidental o consecuente resultante del uso o la imposibilidad de usar este sitio web.',
        },
        {
          title: '5. Enlaces externos',
          content: 'Nuestro sitio web puede contener enlaces a sitios web externos. No somos responsables del contenido o las prácticas de privacidad de estos sitios de terceros.',
        },
        {
          title: '6. Cambios en los términos',
          content: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en esta página.',
        },
        {
          title: '7. Ley aplicable',
          content: 'Estos términos se rigen por las leyes del país donde opera Sparkr. Cualquier disputa estará sujeta a la jurisdicción exclusiva de los tribunales competentes.',
        },
        {
          title: '8. Contacto',
          content: 'Para cualquier pregunta sobre estos términos, contáctenos en contact@sparkr.tech.',
        },
      ],
    },
  };

  const content = termsContent[language];

  return (
    <div className="App">
      <Navigation />
      <main className="legal-page">
        <div className="container">
          <div className="legal-content">
            <h1 className="legal-title">{content.title}</h1>
            <p className="legal-updated">{content.lastUpdated}</p>
            {content.sections.map((section, index) => (
              <section key={index} className="legal-section">
                <h2 className="legal-section-title">{section.title}</h2>
                <p className="legal-section-content">{section.content}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

const Terms: React.FC = () => {
  return <TermsContent />;
};

export default Terms;

